import { collection, doc, getDocs, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { appendSuperuserAudit } from './superuserAuditService';

export async function listTenants() {
  const snap = await getDocs(collection(db, 'tenants'));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() })).sort((a, b) => (a.id || '').localeCompare(b.id || ''));
}

/**
 * @param {Object} data - legalName, shortName, slug (doc id), active
 */
export async function createTenant(data) {
  const id = String(data.slug || data.id || '')
    .trim()
    .toLowerCase();
  if (!id) throw new Error('Slug (document id) is required.');
  const legalName = String(data.legalName || '').trim();
  const shortName = String(data.shortName || '').trim();
  if (!legalName) throw new Error('Legal name is required.');
  if (!shortName) throw new Error('Short name is required.');
  await setDoc(doc(db, 'tenants', id), {
    legalName,
    shortName,
    slug: id,
    active: data.active !== false,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  await appendSuperuserAudit({ action: 'tenant_create', tenantId: id, details: { legalName } });
  return id;
}

export async function updateTenant(tenantId, patch) {
  const id = String(tenantId || '').trim();
  if (!id) throw new Error('Tenant id required.');
  const updates = { updatedAt: serverTimestamp() };
  if ('legalName' in patch) updates.legalName = String(patch.legalName || '').trim();
  if ('shortName' in patch) updates.shortName = String(patch.shortName || '').trim();
  if ('active' in patch) updates.active = patch.active !== false;
  if ('revenueDashboardEnabled' in patch) updates.revenueDashboardEnabled = patch.revenueDashboardEnabled === true;
  if ('enabledPrograms' in patch) {
    updates.enabledPrograms = Array.isArray(patch.enabledPrograms)
      ? [...new Set(patch.enabledPrograms.map((x) => String(x || '').trim()).filter(Boolean))]
      : [];
  }
  await updateDoc(doc(db, 'tenants', id), updates);
  await appendSuperuserAudit({ action: 'tenant_update', tenantId: id, details: patch });
}
